import { IDocumentSource, IDocumentIdentifiable } from "../../../domain/document";
import { AbstractSource } from "../../drawing";

export class DocumentPrintSource extends AbstractSource implements IDocumentSource, IDocumentIdentifiable {
  constructor(getToken: () => string, public readonly id: number, public readonly edition: number, public readonly patientNo: string, public hasWatermark: boolean = false, public withCommitAction: boolean = false) {
    super(getToken);
  }

  protected getSource(): string {
    const url = "/api/document/" + this.id + "/pdf-print?token=" + this.token + "&edition=" + this.edition + "&patientCode=" + this.patientNo + "&hasWatermark=" + this.hasWatermark + "&withCommitAction=" + this.withCommitAction;
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): IDocumentSource {
    return new DocumentPrintSource(
      this._getToken,
      this.id,
      this.edition,
      this.patientNo,
      this.hasWatermark,
      this.withCommitAction,
    );
  }
}
